@if (customFieldDefinitions()) {
    <form
        class="customer-details-form"
        [ngClass]="{ 'customer-details-form--editing': editing() }"
        [formGroup]="customerForm"
        (ngSubmit)="submitForm()"
    >
        <div class="row">
            <div class="col-3 label">
                <label class="form-label" for="firstname">First Name</label>
            </div>
            <div class="col-8">
                <input
                    formControlName="firstName"
                    type="text"
                    class="form-control"
                    [ngbTooltip]="customerForm.get('firstName')?.value"
                    placement="top"
                />
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-3 label">
                <label class="form-label" for="middlename">Middle Name</label>
            </div>
            <div class="col-8">
                <input
                    formControlName="middleName"
                    type="text"
                    class="form-control"
                    [ngbTooltip]="customerForm.get('middleName')?.value"
                    placement="top"
                />
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-3 label">
                <label class="form-label" for="lastname">Last Name</label>
            </div>
            <div class="col-8">
                <input
                    formControlName="lastName"
                    type="text"
                    class="form-control"
                    [ngbTooltip]="customerForm.get('lastName')?.value"
                    placement="top"
                />
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-3 label">
                <label class="form-label" for="email">
                    Email Address
                    <span class="text-danger">*</span>
                </label>
            </div>
            <div class="flex-column col-8 position-relative">
                <input
                    formControlName="email"
                    type="email"
                    class="form-control"
                    validateContactField
                    [formFieldInEditMode]="editing()"
                    [formFieldErrorMessage]="{
                        email: 'Please provide a valid email address.',
                        required: 'Mandatory fields cannot be left blank.',
                        emailExists:
                            'An end customer record exists with this email',
                    }"
                    [ngbTooltip]="customerForm.get('email')?.value"
                    placement="top"
                    name="email"
                />
            </div>
        </div>

        <ng-container formArrayName="phoneNumbers">
            @for (
                phone of phoneNumbers.controls;
                track $index;
                let i = $index;
                let last = $last
            ) {
                <div class="row mt-3" [formGroupName]="i">
                    <div class="col-3 label">
                        @if (i === 0) {
                            <label class="form-label" for="phoneNumbers">
                                Phone Number
                                <span class="text-danger">*</span>
                            </label>
                        }
                    </div>
                    <div
                        [ngClass]="
                            editing() ? 'col-7 position-relative' : 'col-8'
                        "
                    >
                        <input
                            formControlName="number"
                            type="text"
                            class="form-control"
                            validateContactField
                            [formFieldInEditMode]="editing()"
                            [formFieldErrorMessage]="{
                                ukNumber:
                                    'Phone number must start with +44 or 0.',
                                required:
                                    'Mandatory fields cannot be left blank.',
                                phoneNumberExists:
                                    'An end customer record exists with this phone number',
                                startsWithPlus44TooLong:
                                    'Numbers starting +44 have a maximum length of 13 ',
                                startsWithZeroTooLong:
                                    'Numbers starting 0 have a maximum length of 11 ',
                                invalid: 'This phone number is invalid',
                            }"
                            [ngbTooltip]="phone.get('number')?.value"
                            placement="top"
                        />
                    </div>
                    <div
                        [class.d-none]="!editing()"
                        class="col-1 d-flex align-items-center justify-content-center"
                    >
                        <span class="phone-controls">
                            @if (last) {
                                <i
                                    class="fa-light fa-circle-plus"
                                    tabindex="0"
                                    (click)="addPhoneNumber()"
                                    (keypress)="addPhoneNumber()"
                                ></i>
                            } @else {
                                <i
                                    class="fa-light fa-trash"
                                    tabindex="1"
                                    (click)="removePhoneNumber(i)"
                                    (keypress)="removePhoneNumber(i)"
                                ></i>
                            }
                        </span>
                    </div>
                </div>
            }
        </ng-container>

        <ng-container formArrayName="customFields">
            @for (
                customField of customFields.controls;
                track customField.get('fieldDefinitionId');
                let i = $index
            ) {
                <div class="row mt-3" [formGroupName]="i">
                    <div class="col-3 label">
                        <label class="form-label" for="customFields">
                            {{
                                getCustomFieldLabel(
                                    customField.get('fieldDefinitionId')?.value
                                )
                            }}
                        </label>
                    </div>
                    <div class="col-8">
                        <div>
                            @if (!editing()) {
                                <input
                                    formControlName="value"
                                    type="text"
                                    class="form-control"
                                    [ngbTooltip]="
                                        customField.get('value')?.value
                                    "
                                    placement="top"
                                />
                            } @else {
                                @switch (
                                    getCustomFieldType(
                                        customField.get('fieldDefinitionId')
                                            ?.value
                                    )
                                ) {
                                    @case ('Text') {
                                        <input
                                            formControlName="value"
                                            type="text"
                                            class="form-control"
                                            [ngbTooltip]="
                                                customField.get('value')?.value
                                            "
                                            placement="top"
                                        />
                                    }
                                    @case ('Choice') {
                                        <telxl-dropdown
                                            colour="dropdown"
                                            [outline]="true"
                                            [selected]="
                                                getSelectedOption(
                                                    customField.get(
                                                        'fieldDefinitionId'
                                                    )?.value
                                                )
                                            "
                                            [menuItems]="
                                                getCustomFieldOptions(
                                                    customField.get(
                                                        'fieldDefinitionId'
                                                    )?.value
                                                )
                                            "
                                            (selectedChange)="
                                                onOptionSelected(
                                                    customField.get(
                                                        'fieldDefinitionId'
                                                    )?.value,
                                                    $event
                                                )
                                            "
                                            [ngbTooltip]="
                                                customField.get('value')?.value
                                            "
                                            placement="top"
                                        />
                                    }
                                }
                            }
                        </div>
                    </div>
                </div>
            }
        </ng-container>
    </form>
} @else {
    <div class="h-100 w-100">
        <telxl-loading size="3rem" />
    </div>
}
